<style lang="scss" scoped>
.dropdown-item {
  &[disabled] {
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;

    &[disabled] {
      cursor: not-allowed;
    }
  }
}
</style>

<template>
  <td>
    <div ref="dropdown" class="dropdown dropleft" :class="{ show: show }">
      <button
        @click="show = !show"
        :disabled="deleted"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div class="dropdown-item" @click="edit" :disabled="deleting">
          Bearbeiten
        </div>
        <div class="dropdown-item" @click="remove" :disabled="deleting">
          Löschen
        </div>
      </div>
    </div>
  </td>
</template>

<script lang="babel">
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
    props: ['content', 'label', 'model'],
    data() {
      return {
        show: false,
        deleting: false
      };
    },
    computed: {
      activeText() {
        return this.model.active ? 'Deaktivieren' : 'Aktivieren';
      },
      deleted() {
        return Boolean(this.model.deleted_at);
      }
    },
    mounted() {
      catchOutsideClicks(this.$refs.dropdown, () => {
        this.show = false;
      });
    },
    methods: {
      edit() {
        if (this.deleting) {
          return;
        }

        this.$router.push({ path: new URL(this.model.update_page_url).pathname });
      },
      remove() {
        if (this.deleting) {
          return;
        }

        let confirmed = confirm('Sicher?');
        if (!confirmed) {
          return;
        }

        this.deleting = true;

        this.$store.dispatch('customerProfile/delete', { url: this.model.delete_url, id: this.model.id}).then(() => {
          this.$emit('table-update', { count: true });
        }).finally(() => {
          this.deleting = false;
          this.show = false;
        });
      }
    }
};
</script>
